// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__bJ72n","modal__dialog":"Modal_modal__dialog__GDaXD","modal__content":"Modal_modal__content__hNBFe"};